import axiosInstance from "../axiosInstance";
import { normalizarLote, normalizarVto } from "../../utils/normalizarLoteVto";

export const GETVerificarLoteVto = async (lote, producto, vto) => {
  try {
    const response = await axiosInstance.get(
      `${process.env.REACT_APP_WMS_BASE_URL}/auditoria-sma/verificar-lote`,
      {
        params: {
          lote: normalizarLote(lote),
          producto,
          fecha: normalizarVto(vto),
        },
        headers: {
          "Content-Type": "application/json",
        },
      },
    );

    return {
      status: response.status,
      data: response.data,
    };
  } catch (error) {
    return {
      status: error.response?.status,
      data: error.response?.data,
      message:
        error.response?.data?.message || "Error al realizar la solicitud",
    };
  }
};

export default GETVerificarLoteVto;
